import { render, staticRenderFns } from "./LoanBankTable.vue?vue&type=template&id=07a95df1&scoped=true&"
import script from "./LoanBankTable.vue?vue&type=script&lang=js&"
export * from "./LoanBankTable.vue?vue&type=script&lang=js&"
import style0 from "./LoanBankTable.vue?vue&type=style&index=0&id=07a95df1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a95df1",
  null
  
)

export default component.exports